module.exports = __webpack_public_path__ + "static/ekspertas-842eb56f88e4049561af8115ab908c6f.svg";